import { Point } from 'esri/geometry';

// Basic data for save map position, basemap and zoom
export class UrlMapProps {
    basemap: string | null;
    zoom: number | null;
    center: Point | undefined;

    constructor(
        basemap: string | null,
        zoom: number | null,
        center: Point | undefined,
    ) {
        this.basemap = basemap;
        this.zoom = zoom;
        this.center = center;
    }
}
